import React from "react";

import { authRoles } from "app/auth";
import i18next from "i18next";

import vi from "./i18n/vi";
import en from "./i18n/en";
import { isMobileOnly } from "react-device-detect";

i18next.addResourceBundle("en", "weather", en);
i18next.addResourceBundle("vi", "weather", vi);

const WeatherConfig = {
  settings: {
    layout: "admin",
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: "/weather",
      exact: true,
      component: React.lazy(() =>
        isMobileOnly ? import("./weathers.mobile") : import("./weathers")
      ),
    },
  ],
};

export default WeatherConfig;
